import { Navigate, useParams } from 'react-router-dom';

/** Edit opens the category modal on the list page. */
export default function SeedVarietyCategoryEdit() {
  const { categoryId: categoryIdParam } = useParams();
  const id = categoryIdParam ? decodeURIComponent(categoryIdParam) : '';
  if (!id) {
    return <Navigate to="/admin/dashboard/seed-varieties/categories" replace />;
  }
  return (
    <Navigate
      to="/admin/dashboard/seed-varieties/categories"
      replace
      state={{ editCategoryId: id }}
    />
  );
}
